export interface Property {
  id: string;
  title: string;
  price: number;
  priceType: 'sale' | 'rent';
  location: string;
  city: string;
  type: 'House' | 'Apartment' | 'Villa' | 'Studio' | 'Penthouse' | 'Townhouse';
  bedrooms: number;
  bathrooms: number;
  sqft: number;
  image: string;
  images: string[];
  agent: { name: string; avatar: string; phone: string };
  isFeatured: boolean;
  isNew: boolean;
  rating: number;
  description: string;
  amenities: string[];
  yearBuilt: number;
  coords: { lat: number; lng: number };
}

export const properties: Property[] = [
  {
    id: '1',
    title: 'Modern Luxury Villa with Pool',
    price: 1250000,
    priceType: 'sale',
    location: '14 Elmwood Drive, Beverly Hills',
    city: 'Beverly Hills',
    type: 'Villa',
    bedrooms: 5,
    bathrooms: 4,
    sqft: 4200,
    image: 'https://public.readdy.ai/ai/img_res/35d584f9e21c5548f739de8e203c8e72.jpg',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20luxury%20villa%20exterior%20with%20swimming%20pool%2C%20lush%20garden%2C%20white%20architecture%2C%20bright%20sunny%20day%2C%20minimalist%20design%2C%20wide%20angle%20shot%2C%20premium%20real%20estate%20photography&width=800&height=500&seq=prop1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=luxury%20villa%20interior%20living%20room%2C%20open%20plan%2C%20high%20ceilings%2C%20marble%20floors%2C%20designer%20furniture%2C%20natural%20light%2C%20minimalist%20decor&width=800&height=500&seq=prop1b&orientation=landscape',
      'https://readdy.ai/api/search-image?query=luxury%20villa%20master%20bedroom%2C%20king%20bed%2C%20floor%20to%20ceiling%20windows%2C%20garden%20view%2C%20elegant%20interior%20design&width=800&height=500&seq=prop1c&orientation=landscape',
    ],
    agent: { name: 'Sarah Mitchell', avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20real%20estate%20agent%20headshot%2C%20friendly%20smile%2C%20business%20attire%2C%20clean%20white%20background&width=80&height=80&seq=agent1&orientation=squarish', phone: '+1 (310) 555-0192' },
    isFeatured: true,
    isNew: true,
    rating: 4.9,
    description: 'An exceptional modern villa nestled in the heart of Beverly Hills. This stunning property features an open-plan living area, gourmet kitchen, and a resort-style pool surrounded by lush landscaping. Perfect for those seeking the ultimate in luxury living.',
    amenities: ['Swimming Pool', 'Home Theater', 'Smart Home', 'Gym', 'Wine Cellar', 'Garage x3'],
    yearBuilt: 2021,
    coords: { lat: 34.0736, lng: -118.4004 },
  },
  {
    id: '2',
    title: 'Downtown Penthouse with City Views',
    price: 875000,
    priceType: 'sale',
    location: '88 Skyline Tower, Manhattan',
    city: 'Manhattan',
    type: 'Penthouse',
    bedrooms: 3,
    bathrooms: 3,
    sqft: 2800,
    image: 'https://readdy.ai/api/search-image?query=luxury%20penthouse%20apartment%20interior%2C%20floor%20to%20ceiling%20windows%2C%20city%20skyline%20view%20at%20night%2C%20modern%20furniture%2C%20open%20plan%20living%2C%20premium%20real%20estate&width=800&height=500&seq=prop2&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=luxury%20penthouse%20apartment%20interior%2C%20floor%20to%20ceiling%20windows%2C%20city%20skyline%20view%20at%20night%2C%20modern%20furniture%2C%20open%20plan%20living%2C%20premium%20real%20estate&width=800&height=500&seq=prop2&orientation=landscape',
    ],
    agent: { name: 'James Thornton', avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20real%20estate%20agent%20headshot%2C%20confident%20smile%2C%20suit%2C%20clean%20background&width=80&height=80&seq=agent2&orientation=squarish', phone: '+1 (212) 555-0847' },
    isFeatured: true,
    isNew: false,
    rating: 4.8,
    description: 'Breathtaking penthouse perched atop one of Manhattan\'s most iconic towers. Enjoy panoramic city views from every room, a wraparound terrace, and world-class finishes throughout.',
    amenities: ['Rooftop Terrace', 'Concierge', 'Gym', 'Valet Parking', 'Private Elevator'],
    yearBuilt: 2019,
    coords: { lat: 40.7580, lng: -73.9855 },
  },
  {
    id: '3',
    title: 'Charming Townhouse in Kensington',
    price: 4500,
    priceType: 'rent',
    location: '22 Kensington Gardens, London',
    city: 'London',
    type: 'Townhouse',
    bedrooms: 4,
    bathrooms: 3,
    sqft: 2200,
    image: 'https://readdy.ai/api/search-image?query=charming%20Victorian%20townhouse%20exterior%2C%20Kensington%20London%2C%20red%20brick%20facade%2C%20white%20window%20frames%2C%20flower%20boxes%2C%20tree-lined%20street%2C%20elegant%20architecture&width=800&height=500&seq=prop3&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=charming%20Victorian%20townhouse%20exterior%2C%20Kensington%20London%2C%20red%20brick%20facade%2C%20white%20window%20frames%2C%20flower%20boxes%2C%20tree-lined%20street%2C%20elegant%20architecture&width=800&height=500&seq=prop3&orientation=landscape',
    ],
    agent: { name: 'Emily Clarke', avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20real%20estate%20agent%20headshot%2C%20warm%20smile%2C%20business%20casual%2C%20neutral%20background&width=80&height=80&seq=agent3&orientation=squarish', phone: '+44 20 7946 0958' },
    isFeatured: false,
    isNew: true,
    rating: 4.7,
    description: 'A beautifully preserved Victorian townhouse in the prestigious Kensington area. Features original period details alongside modern upgrades, a private garden, and easy access to Hyde Park.',
    amenities: ['Private Garden', 'Fireplace', 'Cellar', 'Parking', 'Period Features'],
    yearBuilt: 1890,
    coords: { lat: 51.5014, lng: -0.1878 },
  },
  {
    id: '4',
    title: 'Beachfront Apartment in Miami',
    price: 620000,
    priceType: 'sale',
    location: '5 Ocean Drive, Miami Beach',
    city: 'Miami',
    type: 'Apartment',
    bedrooms: 2,
    bathrooms: 2,
    sqft: 1400,
    image: 'https://readdy.ai/api/search-image?query=beachfront%20apartment%20building%20exterior%2C%20Miami%20Beach%2C%20modern%20architecture%2C%20ocean%20view%2C%20palm%20trees%2C%20blue%20sky%2C%20luxury%20residential%20building&width=800&height=500&seq=prop4&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=beachfront%20apartment%20building%20exterior%2C%20Miami%20Beach%2C%20modern%20architecture%2C%20ocean%20view%2C%20palm%20trees%2C%20blue%20sky%2C%20luxury%20residential%20building&width=800&height=500&seq=prop4&orientation=landscape',
    ],
    agent: { name: 'Carlos Rivera', avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20real%20estate%20agent%20headshot%2C%20friendly%20expression%2C%20smart%20casual%2C%20light%20background&width=80&height=80&seq=agent4&orientation=squarish', phone: '+1 (305) 555-0234' },
    isFeatured: true,
    isNew: false,
    rating: 4.6,
    description: 'Wake up to stunning ocean views in this beautifully appointed beachfront apartment. Direct beach access, resort-style amenities, and a vibrant location make this a truly special property.',
    amenities: ['Beach Access', 'Pool', 'Gym', 'Concierge', 'Balcony'],
    yearBuilt: 2018,
    coords: { lat: 25.7617, lng: -80.1918 },
  },
  {
    id: '5',
    title: 'Contemporary Studio in SoHo',
    price: 2800,
    priceType: 'rent',
    location: '45 Spring Street, SoHo, NYC',
    city: 'New York',
    type: 'Studio',
    bedrooms: 1,
    bathrooms: 1,
    sqft: 650,
    image: 'https://readdy.ai/api/search-image?query=contemporary%20studio%20apartment%20interior%2C%20SoHo%20New%20York%2C%20exposed%20brick%20wall%2C%20industrial%20chic%20design%2C%20large%20windows%2C%20modern%20minimalist%20furniture%2C%20loft%20style&width=800&height=500&seq=prop5&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=contemporary%20studio%20apartment%20interior%2C%20SoHo%20New%20York%2C%20exposed%20brick%20wall%2C%20industrial%20chic%20design%2C%20large%20windows%2C%20modern%20minimalist%20furniture%2C%20loft%20style&width=800&height=500&seq=prop5&orientation=landscape',
    ],
    agent: { name: 'Priya Sharma', avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20real%20estate%20agent%20headshot%2C%20confident%2C%20modern%20office%20background%2C%20business%20attire&width=80&height=80&seq=agent5&orientation=squarish', phone: '+1 (646) 555-0371' },
    isFeatured: false,
    isNew: true,
    rating: 4.5,
    description: 'A stylish studio in the heart of SoHo, featuring exposed brick, high ceilings, and designer finishes. Walking distance to galleries, restaurants, and boutiques.',
    amenities: ['Doorman', 'Rooftop Access', 'Laundry', 'Bike Storage'],
    yearBuilt: 2015,
    coords: { lat: 40.7233, lng: -74.0030 },
  },
  {
    id: '6',
    title: 'Spacious Family Home in Suburbs',
    price: 485000,
    priceType: 'sale',
    location: '7 Maple Lane, Westchester',
    city: 'Westchester',
    type: 'House',
    bedrooms: 4,
    bathrooms: 3,
    sqft: 2900,
    image: 'https://readdy.ai/api/search-image?query=spacious%20suburban%20family%20home%20exterior%2C%20large%20front%20yard%2C%20green%20lawn%2C%20two-story%20house%2C%20white%20siding%2C%20attached%20garage%2C%20tree-lined%20neighborhood%2C%20sunny%20day&width=800&height=500&seq=prop6&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=spacious%20suburban%20family%20home%20exterior%2C%20large%20front%20yard%2C%20green%20lawn%2C%20two-story%20house%2C%20white%20siding%2C%20attached%20garage%2C%20tree-lined%20neighborhood%2C%20sunny%20day&width=800&height=500&seq=prop6&orientation=landscape',
    ],
    agent: { name: 'David Park', avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20real%20estate%20agent%20headshot%2C%20approachable%20smile%2C%20business%20casual%2C%20neutral%20background&width=80&height=80&seq=agent6&orientation=squarish', phone: '+1 (914) 555-0512' },
    isFeatured: false,
    isNew: false,
    rating: 4.7,
    description: 'A wonderful family home in a sought-after suburban neighborhood. Features a large backyard, updated kitchen, and top-rated school district. Perfect for growing families.',
    amenities: ['Backyard', 'Garage x2', 'Basement', 'Deck', 'Central AC'],
    yearBuilt: 2005,
    coords: { lat: 41.0534, lng: -73.7629 },
  },
  {
    id: '7',
    title: 'Hillside Retreat with Valley Views',
    price: 1850000,
    priceType: 'sale',
    location: '3 Summit Ridge, Malibu',
    city: 'Malibu',
    type: 'Villa',
    bedrooms: 6,
    bathrooms: 5,
    sqft: 5500,
    image: 'https://readdy.ai/api/search-image?query=hillside%20luxury%20villa%20Malibu%2C%20panoramic%20valley%20and%20ocean%20views%2C%20infinity%20pool%2C%20modern%20architecture%2C%20natural%20stone%20and%20wood%2C%20dramatic%20landscape%2C%20golden%20hour%20lighting&width=800&height=500&seq=prop7&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=hillside%20luxury%20villa%20Malibu%2C%20panoramic%20valley%20and%20ocean%20views%2C%20infinity%20pool%2C%20modern%20architecture%2C%20natural%20stone%20and%20wood%2C%20dramatic%20landscape%2C%20golden%20hour%20lighting&width=800&height=500&seq=prop7&orientation=landscape',
    ],
    agent: { name: 'Sarah Mitchell', avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20real%20estate%20agent%20headshot%2C%20friendly%20smile%2C%20business%20attire%2C%20clean%20white%20background&width=80&height=80&seq=agent1&orientation=squarish', phone: '+1 (310) 555-0192' },
    isFeatured: true,
    isNew: false,
    rating: 5.0,
    description: 'An architectural masterpiece perched on a Malibu hillside. This extraordinary estate offers unobstructed ocean and valley views, an infinity pool, and the finest materials throughout.',
    amenities: ['Infinity Pool', 'Home Theater', 'Wine Cellar', 'Helipad', 'Guest House', 'Gym'],
    yearBuilt: 2022,
    coords: { lat: 34.0259, lng: -118.7798 },
  },
  {
    id: '8',
    title: 'Cozy Apartment near Central Park',
    price: 3200,
    priceType: 'rent',
    location: '120 West 72nd Street, NYC',
    city: 'New York',
    type: 'Apartment',
    bedrooms: 2,
    bathrooms: 1,
    sqft: 950,
    image: 'https://readdy.ai/api/search-image?query=cozy%20apartment%20interior%20near%20Central%20Park%20New%20York%2C%20warm%20lighting%2C%20hardwood%20floors%2C%20large%20windows%20with%20park%20view%2C%20tasteful%20modern%20decor%2C%20comfortable%20living%20space&width=800&height=500&seq=prop8&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=cozy%20apartment%20interior%20near%20Central%20Park%20New%20York%2C%20warm%20lighting%2C%20hardwood%20floors%2C%20large%20windows%20with%20park%20view%2C%20tasteful%20modern%20decor%2C%20comfortable%20living%20space&width=800&height=500&seq=prop8&orientation=landscape',
    ],
    agent: { name: 'Priya Sharma', avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20real%20estate%20agent%20headshot%2C%20confident%2C%20modern%20office%20background%2C%20business%20attire&width=80&height=80&seq=agent5&orientation=squarish', phone: '+1 (646) 555-0371' },
    isFeatured: false,
    isNew: false,
    rating: 4.6,
    description: 'A charming pre-war apartment just steps from Central Park. Features original hardwood floors, high ceilings, and a renovated kitchen. Ideal for those who love the Upper West Side lifestyle.',
    amenities: ['Doorman', 'Elevator', 'Laundry', 'Storage', 'Park Views'],
    yearBuilt: 1935,
    coords: { lat: 40.7794, lng: -73.9800 },
  },
  {
    id: '9',
    title: 'Modern Loft in Arts District',
    price: 550000,
    priceType: 'sale',
    location: '200 S. Santa Fe Ave, Los Angeles',
    city: 'Los Angeles',
    type: 'Apartment',
    bedrooms: 2,
    bathrooms: 2,
    sqft: 1600,
    image: 'https://readdy.ai/api/search-image?query=modern%20industrial%20loft%20apartment%20interior%2C%20Arts%20District%20Los%20Angeles%2C%20polished%20concrete%20floors%2C%20exposed%20ductwork%2C%20large%20factory%20windows%2C%20open%20plan%2C%20contemporary%20art%20on%20walls&width=800&height=500&seq=prop9&orientation=landscape',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20industrial%20loft%20apartment%20interior%2C%20Arts%20District%20Los%20Angeles%2C%20polished%20concrete%20floors%2C%20exposed%20ductwork%2C%20large%20factory%20windows%2C%20open%20plan%2C%20contemporary%20art%20on%20walls&width=800&height=500&seq=prop9&orientation=landscape',
    ],
    agent: { name: 'Carlos Rivera', avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20real%20estate%20agent%20headshot%2C%20friendly%20expression%2C%20smart%20casual%2C%20light%20background&width=80&height=80&seq=agent4&orientation=squarish', phone: '+1 (305) 555-0234' },
    isFeatured: false,
    isNew: true,
    rating: 4.8,
    description: 'A stunning converted warehouse loft in LA\'s vibrant Arts District. Soaring ceilings, polished concrete floors, and massive windows create an inspiring living space.',
    amenities: ['Rooftop Deck', 'Gym', 'Dog Friendly', 'EV Charging', 'Bike Storage'],
    yearBuilt: 2017,
    coords: { lat: 34.0407, lng: -118.2349 },
  },
];

export const featuredProperties = properties.filter(p => p.isFeatured);
